export const setRangeForNode = (targetNode: Node) => {
  const range = new Range();

  range.setStartBefore(targetNode);
  range.setEndAfter(targetNode);

  document.getSelection()?.removeAllRanges();
  document.getSelection()?.addRange(range);
};
